import { jsxs, jsx } from 'react/jsx-runtime';
import 'react';
import 'baseui';
import '../../theme/olx-theme/base-theme.js';
import '../../theme/olx-theme/theme.js';
import '../../theme/utils.js';
import '../../theme/types.js';
import { getOverrides } from '../../overrides.js';
import { StyledFieldset, StyledLegend } from './styled-components.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Fieldset = (_a) => {
  var _b = _a, { label, children, overrides } = _b, props = __objRest(_b, ["label", "children", "overrides"]);
  const [Root, rootProps] = getOverrides(overrides == null ? void 0 : overrides.Root, StyledFieldset);
  const [Legend, legendProps] = getOverrides(overrides == null ? void 0 : overrides.Legend, StyledLegend);
  return jsxs(Root, __spreadProps(__spreadValues(__spreadValues({}, props), rootProps), { children: [label && jsx(Legend, __spreadProps(__spreadValues({}, legendProps), { children: label })), children] }));
};

export { Fieldset };
